import type {
    SberBeneficiaryIdentificationDocNonResidentIdentificationDocTypeEnumKey,
    SberCreateBeneficiaryRequest,
} from '@/shared/api'
import { formatDateToIso } from '@/shared/lib/formatters'

import type { TCitizenship, TSmzFormData } from '../model/types'
import type { TAddressFormNotRF, TAddressFormRF } from '../smz-form/address'
import type { TDocumentsFormNotRF, TDocumentsFormRF } from '../smz-form/documents'

const STUB_ACCOUNT = {
    accountNumber: '40702810538000118319',
    bankBIC: '044525225',
    bankCorAccount: '30101810400000000225',
    bankName: 'ПАО СБЕРБАНК',
} as const

const splitPassportNumber = (passportNumber: string) => {
    const digits = passportNumber.replaceAll(/\D/g, '')

    return {
        seria: digits.slice(0, 4),
        number: digits.slice(4, 10),
    }
}

// TODO доработать ручку
export const buildSberBeneficiaryPayload = (
    citizenship: Exclude<TCitizenship, 'unknown'>,
    formData: TSmzFormData,
): SberCreateBeneficiaryRequest => {
    const { personalData, documents, address, sbp } = formData

    switch (citizenship) {
        case 'rf': {
            const documentsRf = documents as TDocumentsFormRF
            const addressRf = address as TAddressFormRF
            const { seria, number } = splitPassportNumber(documentsRf.passportNumber)

            return {
                individual: {
                    contractNumber: 'ДКП02-01/2022',
                    contractDate: '2022-03-15',
                    surname: personalData.surname,
                    name: personalData.name,
                    patronymic: personalData.patronymic,
                    birthDate: formatDateToIso(personalData.birthDate),
                    birthPlace: documentsRf.placeOfBirth,
                    inn: documentsRf.inn,
                    phone: sbp.number,
                    email: personalData.email,
                    regAddress: addressRf.address,
                    isOnlyTaxResidentRF: addressRf.isTaxResident === 'yes',
                    identificationDoc: {
                        identificationDocType: 'Паспорт гражданина РФ',
                        seria,
                        number,
                        issuer: documentsRf.issuedBy,
                        issueDate: formatDateToIso(documentsRf.dateOfIssue),
                        issuerCode: '770-123',
                    },
                    account: {
                        ...STUB_ACCOUNT,
                        phone: sbp.number,
                    },
                },
            }
        }

        case 'not_rf': {
            const documentsNotRf = documents as TDocumentsFormNotRF
            const addressNotRf = address as TAddressFormNotRF

            return {
                individual_non_resident: {
                    contractNumber: 'ДКП02-02/2022',
                    contractDate: '2022-03-15',
                    surname: personalData.surname,
                    name: personalData.name,
                    patronymic: personalData.patronymic,
                    birthDate: formatDateToIso(personalData.birthDate),
                    birthCountry: addressNotRf.birthCountry.code,
                    birthPlace: addressNotRf.placeOfBirth,
                    inn: documentsNotRf.inn,
                    phone: sbp.number,
                    email: personalData.email,
                    identificationDoc: {
                        identificationDocType:
                            documentsNotRf.type as SberBeneficiaryIdentificationDocNonResidentIdentificationDocTypeEnumKey,
                        number: documentsNotRf.documentNumber,
                        issuer: documentsNotRf.issuedBy,
                        issueDate: formatDateToIso(documentsNotRf.dateOfIssue),
                    },
                    addresses: [
                        {
                            typeAddress: 'адрес регистрации',
                            address: '',
                        },
                    ],
                    citizenShips: [
                        {
                            country: addressNotRf.citizenship.code,
                        },
                    ],
                    taxResidenceDifference: {
                        taxResidenceDifference:
                            addressNotRf.residenceCountry.code !== addressNotRf.citizenship.code,
                    },
                    rightOfResidenceUnderInvestmentScheme: {
                        rightOfResidenceUnderInvestmentScheme: {
                            rightOfResidenceUnderInvestmentScheme: false,
                        },
                    },
                    account: {
                        ...STUB_ACCOUNT,
                        phone: sbp.number,
                    },
                },
            }
        }

        default: {
            const _exhaustive: never = citizenship

            throw new Error(`Unsupported citizenship: ${_exhaustive}`)
        }
    }
}
